import { render, staticRenderFns } from "./CrudTableController.vue?vue&type=template&id=42a92e7c&scoped=true"
import script from "./CrudTableController.vue?vue&type=script&lang=js"
export * from "./CrudTableController.vue?vue&type=script&lang=js"
import style0 from "./CrudTableController.vue?vue&type=style&index=0&id=42a92e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a92e7c",
  null
  
)

export default component.exports